import type { SVGProps } from 'react';

const PIN_BODY_D =
  'M9.73 7.63143L13 5.52143C13.1274 5.44418 13.2359 5.33945 13.3176 5.21489C13.3993 5.09034 13.4521 4.9491 13.4723 4.80151C13.4924 4.65391 13.4793 4.50368 13.4339 4.3618C13.3885 4.21991 13.312 4.08996 13.21 3.98143L10 0.771426C9.89147 0.669392 9.76151 0.592893 9.61963 0.547519C9.47775 0.502145 9.32752 0.489043 9.17992 0.50917C9.03232 0.529297 8.89109 0.582144 8.76653 0.66385C8.64198 0.745557 8.53725 0.854058 8.46 0.981426L6.3 4.21143L1.81 5.21143C1.70732 5.23634 1.61304 5.28793 1.5367 5.36097C1.46036 5.43401 1.40465 5.52592 1.37523 5.62739C1.3458 5.72887 1.34369 5.83632 1.36911 5.93887C1.39453 6.04142 1.44658 6.13544 1.52 6.21143L7.67 12.3714C7.74785 12.4419 7.84256 12.491 7.94497 12.5142C8.04739 12.5373 8.15403 12.5336 8.2546 12.5034C8.35516 12.4732 8.44623 12.4176 8.51901 12.342C8.59178 12.2663 8.64379 12.1731 8.67 12.0714L9.73 7.63143Z';

const PIN_TAIL_D = 'M4.59 9.36143L0.5 13.4814';

export function PinIndicatorIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      role="img"
      focusable="false"
      {...props}
    >
      <path d={PIN_BODY_D} />
      <path d={PIN_TAIL_D} />
    </svg>
  );
}
